import { TextItalicIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Italic = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', ...rest } = props;

  return <TextItalicIcon {...rest} size={Sizes[size]} color={fill} />;
};

Italic.displayName = 'Italic';
